import useGetCurrentCustomerData from 'hooks/Authentication/useGetCurrentCustomerData';
import { useGrowthABExperimentsState } from 'hooks/useAssignGrowthABGroups';
import { ABTest } from 'types/growthExperiments.types';
import { VATTypeEnum } from 'types/users.types';

const useShouldApplyPRODiscount = () => {
  const { data: user } = useGetCurrentCustomerData();

  const { experiments } = useGrowthABExperimentsState();

  const isGewerbetreibenderAccount =
    user?.accountType.includes('gewerbetreibender');

  return (
    isGewerbetreibenderAccount &&
    experiments.PRO_GEWERBETREINDER_DISCOUNT === ABTest.B &&
    user?.VATType === VATTypeEnum.subjectToVAT
  );
};

export default useShouldApplyPRODiscount;
